export const supportedLanguages: {
  [key: string]: {
    blogTitle: string;
    blogBasePath: string;
    blogMetadata: {
      title: string;
      description: string;
    };
    blogSlug: string;
    eventTitle: string;
    eventBasePath: string;
    eventMetadata: {
      title: string;
      description: string;
    };
    caseStudyTitle: string;
    caseStudyBasePath: string;
    caseStudyMetadata: {
      title: string;
      description: string;
    };
    caseStudySlug: string;
    careersTitle: string;
    careersBasePath: string;
    careersMetadata: {
      title: string;
      description: string;
    };
    newsTitle: string;
    newsBasePath: string;
    newsMetadata: {
      title: string;
      description: string;
    };
    ebookTitle: string;
    ebookBasePath: string;
    ebookMetadata: {
      title: string;
      description: string;
    };
  };
} = {
  en: {
    blogTitle: 'Blog',
    blogBasePath: 'blog',
    blogMetadata: {
      title: 'QuickFacts Blog',
      description:
        'Welcome to the QuickFacts Blog Page, your go-to source for the latest in the Canadian insurance landscape and insurtech space. Our posts are designed to keep you informed on regulatory changes, technological innovations, and trends within the industry. Stay ahead of the curve with us as we explore the most relevant topics for brokers.',
    },
    blogSlug: 'blog',
    eventTitle: 'Upcoming Events',
    eventBasePath: 'events',
    eventMetadata: {
      title: 'QuickFacts: Upcoming Insurance Events',
      description:
        'Stay up-to-date with upcoming Canadian insurance events, conferences, tradeshows, seminars, and more.',
    },
    caseStudyTitle: 'Case Study',
    caseStudyBasePath: 'case-study',
    caseStudyMetadata: {
      title: 'QuickFacts Case Study',
      description: 'QuickFacts Case Study',
    },
    caseStudySlug: 'case-study',
    careersTitle: 'Careers',
    careersBasePath: 'careers',
    careersMetadata: {
      title: 'QuickFacts: Careers',
      description: 'Find your dream career in the insurance industry.',
    },
    newsTitle: 'News',
    newsBasePath: 'news',
    newsMetadata: {
      title: 'QuickFacts: News',
      description: 'Stay up-to-date with the latest news from QuickFacts.',
    },
    ebookTitle: 'eBooks',
    ebookBasePath: 'ebooks',
    ebookMetadata: {
      title: 'QuickFacts: eBooks',
      description:
        'Discover our collection of eBooks on the Canadian insurance landscape and insurtech space.',
    },
  },
  fr: {
    blogTitle: 'Blogue',
    blogBasePath: 'fr/blogue',
    blogMetadata: {
      title: 'Le QuickFacts Blogue',
      description: 'Bienveneu',
    },
    blogSlug: 'blog-fr',
    eventTitle: 'Événements',
    eventBasePath: 'fr/evenements',
    eventMetadata: {
      title: 'QuickFacts: Événements',
      description: 'Restez informé des dernières événements de QuickFacts.',
    },
    caseStudyTitle: 'Étude de cas',
    caseStudyBasePath: 'fr/etudes-de-cas',
    caseStudyMetadata: {
      title: 'Le QuickFacts Étude de cas',
      description: 'Bienveneu',
    },
    caseStudySlug: 'fr/etudes-de-cas',
    careersTitle: 'Carrières',
    careersBasePath: 'fr/carrieres',
    careersMetadata: {
      title: 'QuickFacts: Carrières',
      description:
        "Trouvez votre carrière idéale dans l'industrie de l'assurance.",
    },
    newsTitle: 'Nouvelles',
    newsBasePath: 'fr/nouvelles',
    newsMetadata: {
      title: 'QuickFacts: Nouvelles',
      description: 'Restez informé des dernières nouvelles de QuickFacts.',
    },
    ebookTitle: 'Livres numériques',
    ebookBasePath: 'fr/livres-numeriques',
    ebookMetadata: {
      title: 'QuickFacts: Livres numériques',
      description:
        "Découvrez notre collection livres numériques sur le paysage de l'assurance au Canada et sur l'insurtech.",
    },
  },
};
